import { render, staticRenderFns } from "./v-select-field.vue?vue&type=template&id=0f1af2b6&scoped=true&"
import script from "./v-select-field.vue?vue&type=script&lang=js&"
export * from "./v-select-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1af2b6",
  null
  
)

export default component.exports